<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'inventoryReservation', params: {} }">
            Inventory Reservation
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'inventoryReservationView', params: {} }">
              View Inventory Reservation
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Inventory Reservation
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="inventoryReservation.processWorksheetId">
            <td max-width="35%" class="text-subtitle-1">Worksheet ID:</td>
            <td>{{ inventoryReservation.processWorksheetId }}</td>
          </tr>
          
          <tr v-if="inventoryReservation.inventoryId">
            <td max-width="35%" class="text-subtitle-1">Inventory ID:</td>
            <td>{{ inventoryReservation.inventoryId }}</td>
          </tr>
          
          <tr v-if="inventoryReservation.inventoryUnitId">
            <td max-width="35%" class="text-subtitle-1">Inventory Unit ID:</td>
            <td>{{ inventoryReservation.inventoryUnitId }}</td>
          </tr>
          
          <tr v-if="inventoryReservation.quantity">
            <td max-width="35%" class="text-subtitle-1">Quantity:</td>
            <td>{{ inventoryReservation.quantity }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getInventoryReservation } from "@/services/inventoryReservation";
    

    export default {
      data() {
        return {
            id: '',
            inventoryReservation: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "inventoryReservationEdit", params: { id: id }});
        },
        setInstance() {
          this.setDependencies().then( () => {
            getInventoryReservation(this.id)
            .then((response) => {
              this.inventoryReservation = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading inventoryReservation");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          return null;
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstance();
        this.$emit("showParent", false);
      }
    }
    </script>
    